import React from 'react';
import t from '@guestyci/localize/t.macro';

const ValidationRules = () => {
  const validationRules = [
    { key: 'minLength', label: t('Minimum 8 characters') },
    { key: 'hasNumber', label: t('One number') },
    { key: 'hasLowercase', label: t('One lowercase letter') },
    { key: 'hasUppercase', label: t('One uppercase letter') },
    { key: 'noEmail', label: t('No email addresses') },
    { key: 'noName', label: t('Not your first or last name') },
  ];

  return (
    <ul className="gst-list-disc gst-pl-5 gst-space-y-2">
      {validationRules.map(({ key, label }) => (
        <li
          key={key}
          className="gst-text-muted-foreground"
        >
          {label}
        </li>
      ))}
    </ul>
  );
};

export default ValidationRules;
